var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],staticStyle:{"background-color":"white","overflow-x":"hidden"}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{attrs:{"id":"certificate-template","src":require("../assets/CyberLabCert.png")}})])
}]

export { render, staticRenderFns }